import DraggableListComponent from './DraggableList';
import DraggableListContainer from './components/DraggableListContainer';
import DraggableListItem from './components/DraggableListItem';

const DraggableList = DraggableListComponent as typeof DraggableListComponent & {
  Item: typeof DraggableListItem;
  Container: typeof DraggableListContainer;
};

DraggableList.Item = DraggableListItem;
DraggableList.Container = DraggableListContainer;

export default DraggableList;
